import { IThemeColors} from "./interfaces";

export const blueTheme : IThemeColors = {
    primary: '#003366',                   // Azul oscuro
    secondary: '#006699',                 // Azul medio
    tertiary: '#0099CC',                  // Azul medio
    bodyBackgroundColor: '#FFFFFF',       // Fondo claro
    secondaryBackground: '#E8E8E8',       // Fondo gris claro

    hover: '#005580',                     // Azul oscuro para hover
    focus: '#00BFFF',                     // Azul claro para foco

    border: '#D1D1D1',                    // Gris claro para bordes
    borderHover: '#006699',               // Azul medio para bordes al pasar el mouse

    buttonPrimary: '#0077B3',             // Azul brillante para botones principales
    buttonPrimaryHover: '#005F8A',        // Azul más oscuro para hover en el botón principal
    buttonSecondary: '#3399FF',           // Azul más claro para botones secundarios
    buttonSecondaryHover: '#007ACC',      // Azul más intenso para hover en el botón secundario
    buttonDanger: '#FF6347',              // Rojo para botones de acción destructiva
    buttonDangerHover: '#D9534F',         // Rojo más oscuro para hover
    buttonText: '#FFFFFF',                // Blanco para el texto de los botones

    buttonDisabled: '#CCCCCC',            // Gris para botones desabilitados

    cardBackground: '#FFFFFF',            // Blanco para fondos de tarjetas
    cardShadow: 'rgba(0, 0, 0, 0.1)',     // Sombra suave para tarjetas
    cardBorder: '#E0E0E0',                // Gris claro para borde de tarjetas

    loadingSpinner: '#006699',            // Azul medio para spinner de carga
    disabled: '#B0B0B0',                  // Gris claro para elementos deshabilitados

    headerBackground: '#003366',          // Azul oscuro para fondo de cabecera
    footerBackground: '#212121',          // Gris oscuro para fondo de pie de página
    footerText: '#FFFFFF',                // Blanco para texto de pie de página

    infoBackground: '#D9EDF7',            // Azul claro para fondo de información
    infoText: '#31708F',                  // Azul oscuro para texto de información
    successBackground: '#DFF0D8',         // Verde claro para fondo de éxito
    successText: '#3C763D',               // Verde oscuro para texto de éxito
    warningBackground: '#FCF8E3',         // Amarillo claro para fondo de advertencia
    warningText: '#8A6D3B',               // Marrón oscuro para texto de advertencia
    errorBackground: '#F2DEDE',           // Rojo claro para fondo de error
    errorText: '#A94442',                 // Rojo oscuro para texto de error

    textPrimary: '#212121',               // Texto principal - Gris oscuro
    textSecondary: '#757575',             // Texto secundario - Gris medio
    textContrast: '#F4F4F4',              // Texto con alto contraste - Blanco/Gris

    linkText: '#1E90FF'                   // Enlaces - Azul brillante
};
export const yellowTheme: IThemeColors = {
    primary: '#FFCC00',                   // Amarillo dorado
    secondary: '#FFB800',                 // Amarillo más cálido
    tertiary: '#FF8800',                  // Naranja brillante
    bodyBackgroundColor: '#FFFFFF',       // Fondo claro
    secondaryBackground: '#F2F2F2',       // Fondo gris muy claro

    hover: '#FFA500',                     // Naranja oscuro para hover
    focus: '#FFD700',                     // Amarillo brillante para foco

    border: '#D3D3D3',                    // Gris muy claro para bordes
    borderHover: '#005F73',               // Azul oscuro para bordes al pasar el mouse

    buttonPrimary: '#FF6F00',             // Naranja intenso para botones principales
    buttonPrimaryHover: '#FF4500',        // Naranja rojizo para hover
    buttonSecondary: '#FFB300',           // Amarillo más fuerte para botones secundarios
    buttonSecondaryHover: '#FF8C00',      // Naranja suave para hover
    buttonDanger: '#FF4C4C',              // Rojo claro para botones de acción destructiva
    buttonDangerHover: '#D9534F',         // Rojo más oscuro para hover
    buttonText: '#FFFFFF',                // Blanco para el texto de los botones
    buttonDisabled: '#CCCCCC',            // Gris para botones desabilitados

    cardBackground: '#FFFFFF',            // Blanco para fondos de tarjetas
    cardShadow: 'rgba(0, 0, 0, 0.2)',     // Sombra más notoria para tarjetas
    cardBorder: '#C0C0C0',                // Gris más fuerte para borde de tarjetas

    loadingSpinner: '#FFD700',            // Amarillo brillante para spinner de carga
    disabled: '#A9A9A9',                  // Gris oscuro para elementos deshabilitados
    
    headerBackground: '#FF8C00',          // Naranja cálido para fondo de cabecera
    footerBackground: '#333333',          // Gris muy oscuro para fondo de pie de página
    footerText: '#F8F8F8',                // Blanco grisáceo para texto de pie de página

    infoBackground: '#B3E5FC',            // Azul pastel para fondo de información
    infoText: '#0288D1',                  // Azul más fuerte para texto de información
    successBackground: '#C8E6C9',         // Verde pastel para fondo de éxito
    successText: '#388E3C',               // Verde intenso para texto de éxito
    warningBackground: '#FFF9C4',         // Amarillo pálido para fondo de advertencia
    warningText: '#F57F17',               // Naranja amarillento para texto de advertencia
    errorBackground: '#FFEBEE',           // Rosa muy claro para fondo de error
    errorText: '#D32F2F',                 // Rojo fuerte para texto de error

    textPrimary: '#212121',               // Texto principal - Gris oscuro
    textSecondary: '#616161',             // Texto secundario - Gris medio
    textContrast: '#FFFFFF',              // Texto con alto contraste - Blanco

    linkText: '#1E88E5'                   // Enlaces - Azul vivo
};
export const redTheme: IThemeColors = {
    primary: '#D32F2F',                   // Rojo oscuro
    secondary: '#E53935',                 // Rojo medio
    tertiary: '#C62828',                  // Rojo fuerte
    bodyBackgroundColor: '#FFFFFF',       // Fondo claro
    secondaryBackground: '#E8E8E8',       // Fondo gris claro

    hover: '#C2185B',                     // Rojo más oscuro para hover
    focus: '#FF4081',                     // Rojo brillante para foco

    border: '#D1D1D1',                    // Gris claro para bordes
    borderHover: '#E53935',               // Rojo medio para bordes al pasar el mouse

    buttonPrimary: '#B71C1C',             // Rojo más oscuro para botones principales (diferente del primario)
    buttonPrimaryHover: '#8B0000',        // Rojo más oscuro para hover en botones principales
    buttonSecondary: '#FF1744',           // Rojo vibrante para botones secundarios
    buttonSecondaryHover: '#D50000',      // Rojo más oscuro para hover en botones secundarios
    buttonDanger: '#FF6347',              // Rojo anaranjado para botones de acción destructiva
    buttonDangerHover: '#D9534F',         // Rojo más oscuro para hover
    buttonText: '#FFFFFF',                // Blanco para el texto de los botones
    buttonDisabled: '#CCCCCC',            // Gris para botones desabilitados

    cardBackground: '#FFFFFF',            // Blanco para fondos de tarjetas
    cardShadow: 'rgba(0, 0, 0, 0.1)',     // Sombra suave para tarjetas
    cardBorder: '#E0E0E0',                // Gris claro para borde de tarjetas

    loadingSpinner: '#E53935',            // Rojo medio para spinner de carga
    disabled: '#B0B0B0',                  // Gris claro para elementos deshabilitados

    headerBackground: '#D32F2F',          // Rojo oscuro para fondo de cabecera
    footerBackground: '#212121',          // Gris oscuro para fondo de pie de página
    footerText: '#FFFFFF',                // Blanco para texto de pie de página

    infoBackground: '#D9EDF7',            // Azul claro para fondo de información
    infoText: '#31708F',                  // Azul oscuro para texto de información
    successBackground: '#DFF0D8',         // Verde claro para fondo de éxito
    successText: '#3C763D',               // Verde oscuro para texto de éxito
    warningBackground: '#FCF8E3',         // Amarillo claro para fondo de advertencia
    warningText: '#8A6D3B',               // Marrón oscuro para texto de advertencia
    errorBackground: '#F2DEDE',           // Rojo claro para fondo de error
    errorText: '#A94442',                 // Rojo oscuro para texto de error

    textPrimary: '#212121',               // Texto principal - Gris oscuro
    textSecondary: '#757575',             // Texto secundario - Gris medio
    textContrast: '#F4F4F4',              // Texto con alto contraste - Blanco/Gris

    linkText: '#D32F2F'                   // Rojo oscuro para enlaces
}
export const greenTheme: IThemeColors = {
    primary: '#006400',                   // Verde oscuro
    secondary: '#2E8B57',                 // Verde más cálido, pero distinto del primario
    tertiary: '#66CDAA',                  // Verde más claro y fresco
    bodyBackgroundColor: '#FFFFFF',       // Fondo claro
    secondaryBackground: '#E8E8E8',       // Fondo gris claro

    hover: '#004d2e',                     // Verde más oscuro para hover
    focus: '#00FA9A',                     // Verde claro y brillante para foco

    border: '#A9A9A9',                    // Gris más oscuro para bordes
    borderHover: '#2E8B57',               // Verde más cálido para bordes al pasar el mouse

    buttonPrimary: '#4CAF50',             // Verde brillante para botones principales
    buttonPrimaryHover: '#388E3C',        // Verde más oscuro para hover en botones principales
    buttonSecondary: '#66CDAA',           // Verde más claro para botones secundarios
    buttonSecondaryHover: '#3B8C6B',      // Verde más oscuro para hover en botones secundarios
    buttonDanger: '#FF6347',              // Rojo para botones de acción destructiva
    buttonDangerHover: '#D9534F',         // Rojo más oscuro para hover
    buttonText: '#FFFFFF',                // Blanco para el texto de los botones
    buttonDisabled: '#CCCCCC',            // Gris para botones desabilitados

    cardBackground: '#FFFFFF',            // Blanco para fondos de tarjetas
    cardShadow: 'rgba(0, 0, 0, 0.1)',     // Sombra suave para tarjetas
    cardBorder: '#E0E0E0',                // Gris claro para borde de tarjetas

    loadingSpinner: '#43A047',            // Verde medio para spinner de carga
    disabled: '#B0B0B0',                  // Gris claro para elementos deshabilitados

    headerBackground: '#006400',          // Verde oscuro para fondo de cabecera
    footerBackground: '#212121',          // Gris oscuro para fondo de pie de página
    footerText: '#FFFFFF',                // Blanco para texto de pie de página

    infoBackground: '#E0F7FA',            // Verde muy claro para fondo de información
    infoText: '#00796B',                  // Verde oscuro para texto de información
    successBackground: '#DFF0D8',         // Verde claro para fondo de éxito
    successText: '#3C763D',               // Verde oscuro para texto de éxito
    warningBackground: '#FCF8E3',         // Amarillo claro para fondo de advertencia
    warningText: '#8A6D3B',               // Marrón oscuro para texto de advertencia
    errorBackground: '#F2DEDE',           // Rojo claro para fondo de error
    errorText: '#A94442',                 // Rojo oscuro para texto de error

    textPrimary: '#212121',               // Texto principal - Gris oscuro
    textSecondary: '#757575',             // Texto secundario - Gris medio
    textContrast: '#F4F4F4',              // Texto con alto contraste - Blanco/Gris

    linkText: '#4CAF50'                   // Verde brillante para enlaces
};

// no use :(
export const darkTheme: IThemeColors = {
    primary: '#1A1A1A',                   // Gris oscuro
    secondary: '#333333',                 // Gris medio
    tertiary: '#666666',                  // Gris claro
    bodyBackgroundColor: '#121212',       // Fondo oscuro
    secondaryBackground: '#1C1C1C',      // Fondo gris oscuro

    hover: '#444444',                     // Gris oscuro para hover
    focus: '#00BFFF',                     // Azul claro para foco

    border: '#333333',                    // Gris oscuro para bordes
    borderHover: '#555555',               // Gris más claro para bordes al pasar el mouse

    buttonPrimary: '#1A1A1A',             // Gris oscuro para botones principales
    buttonPrimaryHover: '#333333',        // Gris más claro para hover
    buttonSecondary: '#666666',           // Gris claro para botones secundarios
    buttonSecondaryHover: '#444444',      // Gris más oscuro para hover
    buttonDanger: '#FF6347',              // Rojo para botones de acción destructiva
    buttonDangerHover: '#D9534F',         // Rojo más oscuro para hover
    buttonText: '#FFFFFF',                // Blanco para el texto de los botones
    buttonDisabled: '#CCCCCC',            // Gris para botones desabilitados

    cardBackground: '#1C1C1C',            // Fondo gris oscuro para tarjetas
    cardShadow: 'rgba(0, 0, 0, 0.7)',     // Sombra más intensa para tarjetas
    cardBorder: '#444444',                // Gris oscuro para borde de tarjetas

    loadingSpinner: '#006699',            // Azul medio para spinner de carga
    disabled: '#808080',                  // Gris medio para elementos deshabilitados

    headerBackground: '#1A1A1A',          // Fondo gris oscuro para cabecera
    footerBackground: '#212121',          // Gris más oscuro para fondo de pie de página
    footerText: '#FFFFFF',                // Blanco para texto del pie de página

    infoBackground: '#D9EDF7',            // Azul claro para fondo de información
    infoText: '#31708F',                  // Azul oscuro para texto de información
    successBackground: '#DFF0D8',         // Verde claro para fondo de éxito
    successText: '#3C763D',               // Verde oscuro para texto de éxito
    warningBackground: '#FCF8E3',         // Amarillo claro para fondo de advertencia
    warningText: '#8A6D3B',               // Marrón oscuro para texto de advertencia
    errorBackground: '#F2DEDE',           // Rojo claro para fondo de error
    errorText: '#A94442',                 // Rojo oscuro para texto de error

    textPrimary: '#FFFFFF',               // Blanco para texto principal
    textSecondary: '#B0B0B0',             // Gris claro para texto secundario
    textContrast: '#F4F4F4',              // Blanco para texto de alto contraste

    linkText: '#1E90FF'                   // Enlaces - Azul brillante
};

export enum ThemeName {
    Blue = "Azul",
    Yellow = "Amarillo",
    Green = "Verde",
    Red = "Rojo",
    Custom = "Personalizado"
}

export interface ThemeItem {
    name : ThemeName,
    label : string,
    theme : IThemeColors
  }

